import { SummaryType } from "@ls/grouping-service";
import { exchange } from "@ls/js-fetch";
import GroupingInput from "state/Constants/GroupingInput";
import SelectionState from "state/selections/SelectionState";
import {
  selectGetGroupingParams,
  selectIsDisableBenchmarkWorkspace,
  selectBenchmarkScenarioValue,
} from "state/selections/selectors";
import { splitByCalcType } from "state/util";
import scope from "./scope";
import { selectDefinitions } from "./selectors";
import { fetchCostBasisOptions } from "@ls/grouping-service";
import ScaleType from "state/Constants/ScaleType";

export const DELETE_DEFINITION = `${scope}/DELETE_DEFINITION`;
export const SET_DEFINITION = `${scope}/SET_DEFINITION`;
export const setDefinition = (idx, definition) => ({
  type: SET_DEFINITION,
  idx,
  definition,
});
export const SET_DEFINITIONS = `${scope}/SET_DEFINITIONS`;
export const setDefinitions = (definitions) => ({
  type: SET_DEFINITIONS,
  definitions,
});

export const REQUEST_BOOK_BASIS_VALUES = `${scope}/REQUEST_BOOK_BASIS_VALUES`;
export const RECEIVE_BOOK_BASIS_VALUES = `${scope}/RECEIVE_BOOK_BASIS_VALUES`;
export const requestBookBasisValues = () => {
  return async (dispatch) => {
    dispatch({ type: REQUEST_BOOK_BASIS_VALUES });
    dispatch({
      type: RECEIVE_BOOK_BASIS_VALUES,
      data: Object.values((await fetchCostBasisOptions()) || {}),
    });
  };
};

export const REQUEST_BOOK_ANALYTICS_DATA = `${scope}/REQUEST_BOOK_ANALYTICS_DATA`;
export const RECEIVE_BOOK_ANALYTICS_DATA = `${scope}/RECEIVE_BOOK_ANALYTICS_DATA`;

export const requestGridData = () => {
  return async (dispatch, getState) => {
    const state = getState();

    const definitions = selectDefinitions(SelectionState.COMMITTED)(state);

    if (!definitions?.length) {
      return;
    }

    const [absDefinitions, bmkDefinitions, relDefinitions] =
      splitByCalcType(definitions);
    const getGroupingParams = selectGetGroupingParams(SelectionState.COMMITTED)(
      state,
    );

    const isDisableBenchmarkWorkspace = selectIsDisableBenchmarkWorkspace(
      SelectionState.COMMITTED,
    )(state);
    const benchmarkScenarioValue = selectBenchmarkScenarioValue(
      SelectionState.COMMITTED,
    )(state);

    const request = async (summary, definitions, benchesToo) => {
      dispatch({ type: REQUEST_BOOK_ANALYTICS_DATA, summary });

      let params = getGroupingParams({
        summary,
        benchesToo,
        analytics: [
          ...new Set(definitions.map(({ bookAnalytic }) => bookAnalytic)),
        ],
        costBases: [...new Set(definitions.map(({ basis }) => basis))],
        inputs: !!definitions.find(
          (def) => def.scaleType === ScaleType.WeightedAverage,
        )
          ? [GroupingInput.BUCKETS]
          : [],
      });

      if (!isDisableBenchmarkWorkspace) {
        params = {
          ...params,
          alt_bench_workspace: !!benchmarkScenarioValue
            ? benchmarkScenarioValue
            : "",
        };
      }

      dispatch({
        type: RECEIVE_BOOK_ANALYTICS_DATA,
        summary,
        data: (
          await exchange({
            params,
            cancelId: `data-${scope}-${summary}`,
            url: process.env.REACT_APP_BASE_URL_GROUPING_SERVICE,
          })
        )?.data,
      });
    };

    if (absDefinitions.length || bmkDefinitions.length) {
      request(
        SummaryType.ABSOLUTE,
        [...absDefinitions, ...bmkDefinitions],
        bmkDefinitions.length > 0,
      ).then();
    }

    if (relDefinitions.length) {
      request(SummaryType.RELATIVE, relDefinitions, true).then();
    }
  };
};
